import type {PropsWithChildren} from 'react';

type Props = PropsWithChildren;

export function PressReleaseInformationRoot({children}: Props) {
  return <div>{children}</div>;
}
